import { formatEmailLink } from '../formatters/formatEmailLink';

export const userEmailRender = (e) => {
    const user = e.data.user;
    return formatEmailLink(user.email);
};
